import { FUND_SUMMARY_MOST_RECENT_MEASUREMENT_DATE } from 'pages/Funds/common/constants';
import { getObjectValue } from 'utilities';
import { OnMeasurementDateChange } from './types';

const onMeasurementDateChange: OnMeasurementDateChange = params => {
  const { event, measurementDates, setCommonMeasurementDate, setSelectedMeasurementDate, setDateQueryParam }
    = params;

  const measurementDateId = event.target.value;

  if (measurementDateId) {
    // Handle "Most Recent" string identifier
    if (measurementDateId === 'most-recent') {
      setSelectedMeasurementDate(FUND_SUMMARY_MOST_RECENT_MEASUREMENT_DATE);
      setDateQueryParam({ date: '' }); // Clear date query param for "Most Recent"
      if (setCommonMeasurementDate) {
        setCommonMeasurementDate('');
      }
      return;
    }

    // Handle regular measurement date selection (numeric ID)
    const selectedMD = getObjectValue(
      measurementDates?.find(measurementDate => measurementDate.id === Number(measurementDateId))
    );

    if (!selectedMD) {
      return;
    }

    const { date, slug } = selectedMD;

    // Handle "Most Recent" selection (empty slug or null ID)
    if (!slug || selectedMD.id === FUND_SUMMARY_MOST_RECENT_MEASUREMENT_DATE.id) {
      setSelectedMeasurementDate(FUND_SUMMARY_MOST_RECENT_MEASUREMENT_DATE);
      setDateQueryParam({ date: '' }); // Clear date query param for "Most Recent"
      if (setCommonMeasurementDate) {
        setCommonMeasurementDate('');
      }
    } else if (date && slug) {
      // Handle regular date selection
      setSelectedMeasurementDate(selectedMD);
      setDateQueryParam({ date: slug });

      if (setCommonMeasurementDate) {
        setCommonMeasurementDate(date);
      }
    }
  }
};

export default onMeasurementDateChange;
